"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateUploadUrlResponseToJSON = exports.CreateUploadUrlResponseFromJSONTyped = exports.CreateUploadUrlResponseFromJSON = exports.instanceOfCreateUploadUrlResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CreateUploadUrlResponse interface.
 */
function instanceOfCreateUploadUrlResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCreateUploadUrlResponse = instanceOfCreateUploadUrlResponse;
function CreateUploadUrlResponseFromJSON(json) {
    return CreateUploadUrlResponseFromJSONTyped(json, false);
}
exports.CreateUploadUrlResponseFromJSON = CreateUploadUrlResponseFromJSON;
function CreateUploadUrlResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'uploadUrl': !(0, runtime_1.exists)(json, 'upload_url') ? undefined : json['upload_url'],
    };
}
exports.CreateUploadUrlResponseFromJSONTyped = CreateUploadUrlResponseFromJSONTyped;
function CreateUploadUrlResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'upload_url': value.uploadUrl,
    };
}
exports.CreateUploadUrlResponseToJSON = CreateUploadUrlResponseToJSON;
